<div class="container-capped px-0 white-bg kp-spinner-container-lg">
	<ngx-spinner name="job-detail" [fullScreen]="true" type="timer"></ngx-spinner>
	<ng-container *ngIf="job">
		<div sticky-bar="light-gray-bg kp-header-shadow" class="pb-1">
			<div class="container d-flex justify-content-between align-items-center" *ngIf="!preview">
				<i class="fa fa-arrow-right f-blue fs-xl py-2 pl-4 pr-1 pointer" (click)="back()"></i>
				<div class="d-flex align-items-center py-2">
					<div class="btn btn-secondary btn-sm mr-2" (click)="setFavorite()">
						<i class="fa-bookmark fs-lg ml-2" [class.fa]="favorite" [class.far]="!favorite"></i>
						<span *ngIf="favorite">نشان شده</span>
						<span *ngIf="!favorite">نشان کن</span>
					</div>
					<div class="btn btn-secondary btn-icon-circle mr-2" title="به اشتراک‌گذاری" (click)="share()">
						<i class="fa fa-share-alt fs-lg"></i>
					</div>

				</div>
			</div>
			<app-subscribe-search #subscribeSearch [params]="searchParams" [source]="'job-detail'" *ngIf="showSubscribe">
			</app-subscribe-search>

		</div>
		<div class="container">
			<app-breadcrumb *ngIf="!preview" [breadcrumb-data]="breadcrumbData" [hide-last]="1"></app-breadcrumb>
			<div class="py-4">
				<div class="kp-card border-dark pt-2" *ngIf="isActive && job.IsSuspect">
					<div class="d-flex align-items-center ">
						<i class="fa fa-exclamation-triangle f-red ml-2 fs-lg"></i>
						<div class="fw-bold fs-lg f-red">هشدار</div>
					</div>
					توجه داشته باشید که دریافت هزینه از کارجو با هر عنوانی <strong>غیرقانونی</strong> است. در صورت مواجهه با
					موارد مشکوک،‌ با کلیک بر روی «گزارش مشکل آگهی» به ما در پیگیری تخلفات کمک کنید.
				</div>
				<div *ngIf="job.Code" class="fs-sm f-gray fsp-1" [copy]="job.Code">
					کد آگهی: KP{{job.Code}}
				</div>
				<div>
					<h1 class="h4 mb-2 wrap">{{job.DisplayTitle}}</h1>
					<div class="d-flex flex-nowrap">
						<div *ngIf="job.Image && !agentTitle" class="ml-2" style="height:60px;width:80px;">
							<img [src]="job.Image?.startsWith('http') ? job.Image : imageUrl+job.Image"
								[alt]="job.Title + ' - ' + job.Company" (error)="$event.target.src=getFavIconSrc(48,true)"
								class="w-100 mw-100 h-100 mh-100 contain" />
						</div>
						<div>
							<div *ngIf="job.Company" class="d-flex align-items-start">
								<span>{{job.Company}} <a class="btn btn-link btn-sm fs-sm" [routerLink]="['/company',job.Employer.code]"
										*ngIf="job.Employer?.code"><i class="fa fa-eye ml-1"></i>پروفایل
										شرکت</a></span>
							</div>
							<div class="d-flex align-items-center"> در {{job.LocationString}} </div>
						</div>
					</div>
				</div>

				<ng-container *ngIf="isActive">

					<div class="border-gray border-2 border-bottom py-1 my-1">
						<div class="d-flex align-items-center fs-sm  f-gray">
							<ng-container *ngIf="agentTitle">
								<img [src]="job.Image?.startsWith('http') ? job.Image : imageUrl+job.Image" [alt]="agentTitle"
									class="icon-sm ml-1" (error)="$event.target.src=getFavIconSrc(48,true)" />
								<span>از {{agentTitle}}</span>
							</ng-container>
							<ng-container *ngIf="!agentTitle && showSource">
								<img class="icon-sm ml-1" *ngIf="job.SourceDomain" [src]="getFavIconSrc()" />
								<i *ngIf="!job.SourceDomain" class="fa ml-1 fs-lg f-gray" [class.fa-telegram]="job.SourceType==2"
									[class.fa-instagram]="job.SourceType==3" [class.fa-globe]="job.SourceType==1"></i>
								<span class="">در {{job.SourceTypeTitle}} {{job.SourceName}}</span>
							</ng-container>
							&nbsp;<span class="f-gray" title="زمان انتشار در کارپیشه"
								*ngIf="job.StartTime">({{job.StartTime|pdate:true}})</span>
						</div>
						<div class="d-flex align-items-center my-1">
							<span *ngIf="job.IsPaid" class="badge badge-pill border fs-sm fw-normal  p-0 ml-1">
								<img class="icon-sm" src="/assets/images/icons/vanguard.svg" alt="آگهی پیشتاز" />
								<span class="p-1 pl-2">آگهی پیشتاز</span>
							</span>

							<span *ngIf="job.IsAppliable" class="badge badge-pill border fs-sm fw-normal  p-0 ml-1">
								<span class="icon-easy-apply icon-sm"></span>
								<span class="p-1 pl-2">استخدام آسان</span>
							</span>
							<span *ngIf="job.IsRemote" class="badge badge-pill border fs-sm fw-normal  p-0 ml-1">
								<i class="fa fa-home fs-lg f-green"></i>
								<span class="p-1 pl-2">دورکاری</span>
							</span>
							<span *ngIf="job.Vacancies > 1" class="badge badge-pill border fs-sm fw-normal p-0 ml-1">
								<img class="icon-sm" src="/assets/images/icons/employ-multiple.svg" alt="استخدام چند نفر" />
								<span class="p-1 pl-2">استخدام {{job.Vacancies}} نفر</span>
							</span>

						</div>
					</div>
					<ng-container>
						<ng-container *ngIf="job.IsKarpashaJob && seekerJob">
							<div class="kp-message kp-message-success mx-0">
								درخواست شما برای معرفی مستقیم به کارفرمای این فرصت شغلی با موفقیت ثبت شده است.
								برای سریع‌تر شدن فرایند بررسی حتما پرونده کاریابی خود را تکمیل و سوابق شغلی، تحصیلات و مهارت‌های خود را
								وارد کنید.
								<div class="p-2">
									<a class="btn btn-primary w-100" routerLink="/karpasha/status"
										[queryParams]="{applyJobId: job.Id}">تکمیل اطلاعات پرونده</a>
								</div>

							</div>
						</ng-container>
						<div class="d-none d-md-flex mr-2" *ngIf="applyMode == 'applied'">
							<a *ngIf="!seekerJob" class="btn btn-secondary flex-grow-1" routerLink="/seeker/profile"
								[queryParams]="{tab:'applies'}"><i class="fa fa-check fs-xl ml-1 f-green"></i>درخواست ارسال شده</a>
							<a *ngIf="seekerJob" class="btn btn-secondary flex-grow-1" [routerLink]="['/seeker','karpasha',job.Id]">
								<i class="fa fa-check fs-xl ml-1 f-green"></i>درخواست ارسال شده</a>
						</div>
						<div class="kp-card kp-card-border relative" *ngIf="applyMode == 'bought'" [ngSwitch]="apply.BoughtStatus">
							<ngx-spinner name="request" [fullScreen]="false" size="small" type="timer"></ngx-spinner>
							<div>
								کارفرما اطلاعات شما را مشاهده کرده و از شما برای همکاری در این شغل دعوت کرده است.
							</div>
							<ng-container *ngSwitchCase="4">
								<div>
									شما در تاریخ {{apply.RequestReplyTime | pdate:'[yyyy]/[mm]/[dd]' }} این درخواست را پذیرفته‌اید.
									اطلاعات
									تماس شما در اختیار کارفرما قرار گرفته است
								</div>
							</ng-container>
							<ng-container *ngSwitchCase="5">
								<div>
									شما در تاریخ {{apply.RequestReplyTime | pdate:'[yyyy]/[mm]/[dd]' }} این درخواست را رد کرده‌اید. در
									صورتی
									که نظرتان عوض شده است با استفاده از دکمه زیر درخواست همکاری را بپذیرید.
								</div>
								<div class="text-center p-1">
									<div class="btn btn-green px-3 px-md-5" (click)="acceptRequest()">
										<i class="fa fa-check fs-lg ml-1"></i>
										می‌پذیرم
									</div>
								</div>
							</ng-container>
							<ng-container *ngSwitchDefault>
								<div class="p-1" *ngIf="!user">
									<app-login [inline]="true" intro="برای پذیرفتن این درخواست باید وارد حساب کاربری خود شوید"
										[mobile]="'0' + apply.User?.username" loginText="ورود" [heading]="undefined">
									</app-login>
								</div>
								<div class="p-1" *ngIf="user">
									<div>لطفا اطلاعات درج شده
										در این صفحه را به دقت مطالعه کنید و در صورتی که تمایل به همکاری دارید دکمه "می‌پذیرم" را لمس کنید
									</div>
									<div class="d-flex justify-content-between align-items-center p-1">
										<div class="btn btn-primary px-md-5" (click)="acceptRequest()">
											<i class="fa fa-check fs-lg ml-1"></i>
											می‌پذیرم
										</div>
										<div class="btn btn-secondary border-red f-red" (confirm)="rejectRequest()">
											<i class="fa fa-times fs-lg ml-1"></i>
											نمی‌پذیرم
										</div>
									</div>
								</div>
							</ng-container>
						</div>
					</ng-container>

					<div class="pb-2 my-3 d-md-flex">
						<div class="flex-fill mb-3 mb-md-0 overflow-x-auto">
							<h5 class="fw-bold mb-3 d-flex"><i class="fa fa-info fs-xl ml-2"></i><span>اطلاعات شغل:</span></h5>
							<div class="">
								<div *ngIf="job.IsRemote" class=""><span class="fw-bold">امکان دورکاری و کار در منزل:</span>&nbsp;دارد
								</div>
								<div *ngIf="job.Industries?.length" class=""><span class="fw-bold">زمینه فعالیت:</span>&nbsp;
									{{job.Industries | join: ' - '}}
								</div>
								<div *ngIf="job.JobTypes?.length" class=""><span class="fw-bold">نوع
										همکاری:</span>&nbsp;
									{{job.JobTypes | join: ' - '}}
								</div>
								<div *ngIf="job.Educations?.length">
									<span class="fw-bold">مدرک تحصیلی مورد نیاز:</span>&nbsp;
									{{job.Educations | join: ' - '}}
								</div>
								<div *ngIf="job.MinAge || job.MaxAge">
									<span class="fw-bold">بازه سنی:</span>&nbsp;
									<span *ngIf="job.MinAge">از {{job.MinAge}} </span>
									<span *ngIf="job.MaxAge">تا {{job.MaxAge}} </span>
									سال
								</div>
								<div *ngIf="job.Gender!=-1">
									<span class="fw-bold">جنسیت:</span>&nbsp;
									<ng-container [ngSwitch]="job.Gender">
										<ng-container *ngSwitchCase="0">آقا</ng-container>
										<ng-container *ngSwitchCase="1">خانم</ng-container>
									</ng-container>
								</div>
								<div *ngIf="job.MaritalStatus!=-1">
									<span class="fw-bold">وضعیت تاهل:</span>&nbsp;
									<ng-container [ngSwitch]="job.MaritalStatus">
										<ng-container *ngSwitchCase="1">مجرد</ng-container>
										<ng-container *ngSwitchCase="2">متاهل</ng-container>
									</ng-container>
								</div>
								<div *ngIf="job.MilitaryExcludeNotServed">
									<span class="fw-bold">وضعیت نظام وظیفه:</span>&nbsp;
									کارت پایان خدمت یا معافیت
								</div>
								<div *ngIf="job.RequiredSkills?.length">
									<span class="fw-bold">مهارت‌های مورد نیاز:</span>
									<div>
										<div class="badge badge-pill light-gray-bg  ml-1 mb-0 mt-1 fs-normal fw-normal"
											*ngFor="let skill of job.RequiredSkills">
											{{skill}}
										</div>
									</div>
								</div>
								<div *ngIf="job.MinExperienceYear != undefined">
									<span class="fw-bold">نیاز به سابقه:</span>&nbsp;
									<span>{{job.MinExperienceYear
										? 'حداقل ' + job.MinExperienceYear + ' سال'
										: 'ندارد'
										}}</span>
								</div>
								<div *ngIf="job.DrivingLicenses?.length > 0">
									<span class="fw-bold">گواهینامه رانندگی:</span>&nbsp;
									<span>{{job.DrivingLicenses|readable:dringTranslation|join: ' - '}}</span>
								</div>
								<div *ngIf="job.Certificates?.length > 0">
									<span class="fw-bold">مدارک و گواهینامه‌ها:</span>&nbsp;
									<span>{{job.Certificates|join: ' - '}}</span>
								</div>
								<div *ngIf="job.Languages?.length > 0">
									<span class="fw-bold">زبان‌ها:</span>&nbsp;
									<span>{{job.Languages|join: ' - '}}</span>
								</div>
								<div *ngIf="job.HasInsurance">
									<span class="fw-bold">بیمه:</span>&nbsp;
									<span>دارد</span>
								</div>
								<ng-container *ngIf="job.MinSalary || job.MaxSalary">
									<div *ngIf="job.MinSalary == job.MaxSalary">
										<span class="fw-bold">حقوق:</span>&nbsp;
										<span *ngIf="job.MinSalary">{{job.MinSalary|number}} </span>
										تومان
									</div>
									<div *ngIf="job.MinSalary != job.MaxSalary">
										<span class="fw-bold">بازه حقوق:</span>&nbsp;
										<span *ngIf="job.MinSalary">از {{job.MinSalary|number}} </span>
										<span *ngIf="job.MaxSalary">تا {{job.MaxSalary|number}} </span>
										تومان
									</div>
								</ng-container>
								<div *ngIf="job.PaymentTypeString">
									<span class="fw-bold">نحوه پرداخت:</span>&nbsp;
									<span>{{job.PaymentTypeString}}</span>
								</div>
								<div *ngIf="job.PaymentText?.length">
									<span class="fw-bold">پرداخت‌ها:</span>&nbsp;
									<span>{{job.PaymentText | join:'، '}}</span>
								</div>
								<div *ngIf="job.OpeningHoursText">
									<span class="fw-bold">ساعت کاری:</span>&nbsp;
									<span>{{job.OpeningHoursText}}</span>
								</div>
								<div *ngIf="job.MilitaryBonus">
									<span class="fw-bold">امکان امریه سربازی:</span>&nbsp;
									<span>دارد</span>
								</div>
								<div *ngIf="job.Bonuses?.length">
									<span class="fw-bold">سایر مزایا:</span>&nbsp;
									<span>{{job.Bonuses | join:'، '}}</span>
								</div>
							</div>
						</div>
						<div class="w-md-50 " *ngIf="job.Images?.length && job.SourceType!=3">
							<div id="carouselIndicators" class="carousel slide" data-ride="carousel">
								<ol class="carousel-indicators">
									<li data-target="#carouselIndicators" *ngFor="let img of job.Images;let i=index"
										[attr.data-slide-to]="i" [class.active]="i==0"></li>
								</ol>
								<div class="carousel-inner">
									<div class="carousel-item" *ngFor="let img of job.Images;let i=index" [class.active]="i==0">
										<img class="d-block w-100" [src]="img.Url" [alt]="img.Text">
									</div>
								</div>
								<a *ngIf="job.Images?.length > 1" class="carousel-control-prev" data-target="#carouselIndicators"
									role="button" data-slide="prev">
									<span class="carousel-control-prev-icon" aria-hidden="true"></span>
									<span class="sr-only">قبلی</span>
								</a>
								<a *ngIf="job.Images?.length > 1" class="carousel-control-next" data-target="#carouselIndicators"
									role="button" data-slide="next">
									<span class="carousel-control-next-icon" aria-hidden="true"></span>
									<span class="sr-only">بعدی</span>
								</a>
							</div>

						</div>
					</div>
					<div class="row m-0 border-gray  border-2 border-bottom mb-2">
						<div class="col-12 col-md p-0 py-2 leaf-pre-line">
							<h5 class="fw-bold d-flex"><i class="fa fa-align-right ml-2 fs-xl"></i><span>متن کامل آگهی:</span>
							</h5>
							<div class="text-justify fs-lg long-text wrap  my-2  p-2 overflow-auto"
								[innerHTML]="(job.Description || job.Title)" [attr.dir]="job.IsLtr ? 'ltr' : undefined">
							</div>
							<div class="d-flex flex-wrap">
								<h6 *ngFor="let tag of job.Tags" class="px-1 x-light-gray-bg fw-normal border rounded-xl pointer m-1">
									{{tag}}</h6>
							</div>
							<json-ld *ngIf="schema" [json]="schema"></json-ld>
						</div>
						<div class="col-12 col-md-7 overflow-auto order-first order-md-last p-0 pr-md-2 py-2 text-center"
							*ngIf="job.SourceType==3">
							<!-- instagram -->
							<div class="w-100 overflow-auto">
								<app-embed-ig [url]="job.SourceUrl" class="d-block"></app-embed-ig>
							</div>
						</div>
					</div>
					<ng-container *ngIf="!preview">
						<p class="mb-0">
							<ng-container *ngIf="showSource">
								این آگهی از {{job.SourceTypeTitle}} {{job.SourceName}} پیدا شده، با زدن دکمه‌ی تماس با کارفرما، به
								{{job.SourceTypeTitle}} {{job.SourceName}} برین و از اون‌جا
								برای این شغل اقدام کنین. </ng-container>
							<ng-container *ngIf="!showSource">
								<div class="kp-message kp-message-info x-dark-blue-bg mx-0" *ngIf="job.IsKarpashaJob && !seekerJob">
									اگه این شغل رو می‌خوای دکمه "تماس با کارفرما" رو بزن و فرم رو تکمیل کن.
									<br />
									در صورتی که واجد شرایط باشی با تو تماس می‌گیریم.
								</div>
								<ng-container *ngIf="!job.IsKarpashaJob" [ngSwitch]="job.Kind">
									<ng-container *ngSwitchCase="Kind.Call">
										اگه این شغل رو می‌خوای دکمه "تماس با کارفرما" رو بزن و به روشی که تعیین شده با کارفرما تماس بگیر.
									</ng-container>
									<ng-container *ngSwitchCase="Kind.Basic">
										اگه این شغل رو می‌خوای دکمه "تماس با کارفرما" رو بزن و به سوالات پاسخ بده و منتظر باش تا کارفرما
										باهات
										تماس بگیره.
									</ng-container>
									<ng-container *ngSwitchCase="Kind.Resume">
										اگه این شغل رو می‌خوای دکمه "تماس با کارفرما" رو بزن و رزومه‌ات رو تکمیل کن. کارفرما بعد از بررسی
										رزومه
										باهات تماس می‌گیره.
									</ng-container>
									<ng-container *ngSwitchCase="Kind.Website">
										اگه این شغل رو می‌خوای دکمه "تماس با کارفرما" رو بزن تا به سایت اصلی منتقل بشی. از سایت اصلی، روشی
										که
										کارفرما تعیین کرده رو انجام بده.
									</ng-container>
									<ng-container *ngSwitchDefault>
										<ng-container *ngIf="job.SourceUrl">
											اگه این شغل رو می‌خوای دکمه "تماس با کارفرما" رو بزن تا به سایت اصلی منتقل بشی. از سایت اصلی، روشی
											که کارفرما تعیین کرده رو انجام بده.
										</ng-container>
									</ng-container>
								</ng-container>
							</ng-container>
						</p>
						<div class="py-2 px-md-3 my-2" *ngIf="!job.IsKarpashaJob">
							<div class="border border-dark rounded-xl fs-sm lh-sm p-2 text-justify">
								<div class="d-flex align-items-center f-red">
									<i class="fa fa-exclamation-triangle ml-2 fs-lg"></i>
									<div class="fw-bold fs-lg">هشدار</div>
								</div>
								توجه داشته باشید که دریافت هزینه از کارجو برای استخدام با هر عنوانی غیرقانونی است. در صورت مواجهه با
								موارد
								مشکوک،‌ با کلیک بر روی «گزارش مشکل آگهی» به ما در پیگیری تخلفات کمک کنید.
							</div>
							<div (click)="reportJob.open()" class="d-none d-md-block text-left f-hover-red fw-bold pointer p-1">
								<i class="fa fa-flag ml-1 fs-lg"></i>
								گزارش مشکل آگهی
							</div>
						</div>

						<section class="pt-4 pb-2 sticky-bottom container-capped-xs ml-0 px-0">
							<div class="overflow-auto relative white-bg rounded-xl p-2 shadow-kp"
								style="display: none;max-height: 300px" id="job-detail-contact">
								<i class="fa fa-times float-left fs-lg" (click)="toggleShowContact()"></i>
								<h6 class="px-2 fw-bold"><i class="fa fa-phone ml-2"></i><span>اطلاعات
										تماس:</span></h6>
								<div class="p-3 fs-lg rounded-xl border border-dark">
									<div *ngIf="!job.HasContactInfo">اطلاعات تماس ثبت نشده است </div>
									<div *ngIf="job.ContactName">نام: <span class="float-left">{{job.ContactName}} <i
												class="fas fa-user"></i></span> </div>
									<div *ngIf="job.Phone">شماره تماس: <a class="float-left" href="tel:{{job.Phone}}">{{job.Phone}} <i
												class="fas fa-phone"></i></a></div>
									<div *ngIf="job.Email">ایمیل: <a class="float-left" href="mailto:{{job.Email}}">{{job.Email}} <i
												class="fas fa-envelope"></i></a></div>
									<div *ngIf="job.ContactDescription" class="my-1 border-top">
										<h6>توضیحات:</h6>
										<pre class="my-1 pre-wrap">{{job.ContactDescription}}</pre>
									</div>
								</div>
							</div>
							<!-- <div class="mb-3" style="display: none;" *ngIf="agent" id="job-detail-agent">
								<div class="">
									<div class="fs-sm f-green">تماس با دفتر مشاوره شغلی و کاریابی مرتبط با این آگهی</div>
									<div class="">
										<h2>{{agentTitle}}</h2>
									</div>
									<div class="" *ngIf="agent.Agent.Phones?.length">
										تلفن: <a *ngFor="let tel of agent.Agent.Phones" href="tel:+{{tel}}"><span
												dir="ltr">{{tel}}</span>&nbsp;&nbsp;</a>
									</div>
									<div class="" *ngIf="agent.Agent.Faxes?.length">
										فکس: <a *ngFor="let tel of agent.Agent.Faxes" href="tel:+{{tel}}"><span
												dir="ltr">{{tel}}</span>&nbsp;&nbsp;</a>
									</div>
								</div>
							</div> -->
							<div class="d-flex">
								<ng-container *ngIf="job.IsKarpashaJob && !seekerJob">
									<div class="btn btn-primary flex-fill" [ga-event]="'job-click-karpasha|seeker'"
										title="تماس با کارفرما" (click)="applyKarpashaModal.open() && false">تماس با کارفرما</div>
								</ng-container>
								<ng-container *ngIf="!job.IsKarpashaJob">
									<div *ngIf="agentTitle" class="btn btn-primary relative flex-fill btn-secondary ml-2"
										(click)="toggleShowContact()">
										<i class="fa fa-phone ml-1"></i> تماس با کاریابی
									</div>
									<div class="btn btn-primary relative flex-fill" *ngIf="!agentTitle && job.HasContactInfo && job.Kind==Kind.Call"
										(click)="toggleShowContact();" title="تماس با کارفرما">
										<ngx-spinner name="contact" [fullScreen]="false" size="small" type="timer"></ngx-spinner>
										<i class="fa fa-phone ml-1"></i> تماس با کارفرما
									</div>
									<a class="btn btn-primary flex-fill" *ngIf="applyMode == 'apply'"
										[routerLink]="['/seeker','apply',job.Id]" ga-event="apply|seeker|{{job?.Code}}"
										title="ارسال درخواست به کارفرما">
										<div><span class="icon-easy-apply icon-sm"></span>ارسال درخواست به کارفرما</div>
									</a>
									<ng-container *ngIf="applyMode != 'apply' && job.SourceUrl">
										<a *ngIf="autoRedirect" class="btn btn-primary flex-fill" [title]="openSourceUrlTitle"
											(click)="replaceState(job.SourceUrl)" [href]="job.SourceUrl">{{openSourceUrlTitle}}</a>
										<div *ngIf="!autoRedirect" class="btn btn-primary flex-fill"
											[ga-event]="'job-click-modal|seeker|' + job?.SourceName" [title]="openSourceUrlTitle"
											(click)="redirectModal.open() && false">{{openSourceUrlTitle}}</div>
									</ng-container>
									<ng-container *ngIf="applyMode == 'applied'">
										<a *ngIf="!seekerJob" class="btn btn-white mr-3 flex-grow-1" routerLink="/seeker/profile"
											[queryParams]="{tab:'applies'}"><i class="fa fa-check fs-xl ml-1 f-green"></i>درخواست ارسال
											شده</a>
										<a *ngIf="seekerJob" class="btn btn-white mr-3 flex-grow-1"
											[routerLink]="['/seeker','karpasha',job.Id]">
											<i class="fa fa-check fs-xl ml-1 f-green"></i>درخواست ارسال شده</a>
									</ng-container>
								</ng-container>

							</div>
						</section>
						<div class="container-capped-xs ml-0 px-0">
							<div class="btn btn-secondary w-100 my-1" title="به اشتراک‌ گذاری" (click)="share()"
								ga-event="share|job-detail">
								<div class="w-100 text-right pr-4">
									<i class="fa fa-share-alt fs-lg ml-2"></i>
									این آگهی رو برای دیگران بفرست
								</div>
							</div>
							<div class="btn btn-secondary w-100 my-1 relative" (click)="setFavorite()">
								<ngx-spinner name="favorite" [fullScreen]="false" size="small" type="timer"></ngx-spinner>
								<div class="w-100 text-right pr-4">
									<ng-container *ngIf="!favorite">
										<i class="far fa-bookmark fs-lg ml-2"></i>
										نشان کن
									</ng-container>
									<ng-container *ngIf="favorite">
										<i class="fa fa-bookmark fs-lg f-blue ml-2"></i>
										از نشان‌شده‌ها حذف کن
									</ng-container>
								</div>
							</div>
							<div (click)="reportJob.open()" class="btn btn-secondary w-100 my-1">
								<div class="w-100 text-right pr-4">
									<i class="fa fa-flag ml-1 fs-lg ml-2"></i>
									گزارش مشکل آگهی
								</div>
							</div>
						</div>
						<div class="my-3" *ngIf="showSource && (taggedJobTitles?.length || searchedTagKeywords?.length)">
							<h6>جستجوهای مرتبط</h6>
							<div class="d-flex flex-column">
								<div *ngFor="let item of taggedJobTitles|slice:0:5">
									<a class="f-dark-blue my-1"
										[routerLink]="['/job',Utility.removeUndefined({q: item,l:Utility.locationSearch(job.State, job.City)})]">
										استخدام {{item}} <ng-container *ngIf="job.State">در {{job.LocationString}}
										</ng-container>
									</a>
									(<a class="f-dark-blue my-1"
										[routerLink]="['/job',Utility.removeUndefined({q: item,l:Utility.locationSearch(job.State, job.City)})]">
										{{item}} <ng-container *ngIf="job.State">{{job.LocationString}}
										</ng-container>
									</a>)
								</div>
								<a class="f-dark-blue my-1" *ngFor="let item of searchedTagKeywords|slice:0:5"
									[routerLink]="['/job',Utility.removeUndefined({q: item})]">{{item}}</a>
							</div>
						</div>

					</ng-container>


				</ng-container>

			</div>

		</div>
	</ng-container>
</div>

<ngx-smart-modal #applyKarpashaModal identifier="applyKarpashaModal" customClass="">
	<div class="container-capped-sm p-3" *ngIf="applyKarpashaModal.visible">
		<div class="py-2 my-2" [class.d-none]="user">
			<div>برای ثبت درخواست با شماره موبایلت وارد شو.</div>
			<app-login [inline]="true" [flat]="true" [heading]="''" [intro]="''" registerType="Seeker"
				(auth)="job._hideLink=true">
			</app-login>
		</div>
		<div class="py-2 my-2" *ngIf="user">
			<p class="text-justify mb-1">
				در صورت تناسب این شغل با توانایی‌هایتان، کارپیشه شما را مستقیما به کارفرما معرفی می‌کند و در جریان مذاکرات با
				کارفرما، تا رسیدن به نتیجه همراه شماست.
				<br />
				در صورت موافقت دو طرف و استخدام موفق، <a class="fw-bold f-blue"
					href="https://karyabi.mcls.gov.ir/icm_content/media/image/2023/06/650658_orig.pdf" target="_blank">تعرفه مصوب
					کاریابی</a> از شما
				دریافت خواهد شد.
			</p>
			<div class="py-1 text-left">
				<a class="fs-sm f-blue" href="https://karyabi.mcls.gov.ir/icm_content/media/image/2023/06/650658_orig.pdf"
					target="_blank">
					مشاهده تعرفه کاریابی‌
				</a>
			</div>
			<form #karpashaApplyForm="ngForm" class="kp-spinner-container-lg"
				(submit)="Utility.validate(karpashaApplyForm) && applyKarpasha()" *ngIf="!seekerJob">
				<ngx-spinner name="apply-karpasha" [fullScreen]="true" type="timer"></ngx-spinner>

				<label class="mx-1 mb-1 d-flex align-items-center">
					<input type="checkbox" name="karpasha-agree" [(ngModel)]="karpashaAgreed" required />
					<span> با شرایط بالا موافقم</span>
				</label>
				<div class="p-2">
					<button type="submit" class="btn btn-primary my-1 w-100" [disabled]="!karpashaApplyForm.valid">
						ثبت درخواست
					</button>
				</div>

			</form>
			<div class="kp-message kp-message-success mx-0" *ngIf="seekerJob">
				<h6>درخواست شما ثبت شد.</h6>
				برای سریع‌تر شدن فرایند بررسی حتما پرونده کاریابی خود را تکمیل و سوابق شغلی، تحصیلات و مهارت‌های خود را وارد
				کنید.
				<div class="p-2">
					<a class="btn btn-primary w-100" routerLink="/karpasha/status">تکمیل اطلاعات پرونده</a>
				</div>
			</div>

		</div>

	</div>
</ngx-smart-modal>
<ngx-smart-modal #redirectModal identifier="redirectModal" customClass="full-width">
	<div class="container-capped-sm p-3" *ngIf="job">
		<div class="text-center pb-2">
			<img style="width: 48px;height: 48px" *ngIf="job.SourceDomain" [src]="getFavIconSrc(48)" />
			<i class="fa fa-exchange-alt fs-xxl m-2 fw-bold f-x-dark-blue"></i>
			<img style="width: 48px;height: 48px" *ngIf="job.SourceDomain"
				[src]="'https://www.google.com/s2/favicons?sz=48&domain=karpishe.com'" />
		</div>
		<div class="text-justify">
			این آگهی
			<ng-container *ngIf="agentTitle">از <span class="fw-bold">{{agentTitle}}</span></ng-container>
			در {{job.SourceTypeTitle}} <span class="fw-bold">{{job.SourceName}}</span>
			ثبت شده.<br />
			شما رو به اون سایت می‌فرستیم تا از اون‌جا برای این شغل اقدام کنی.<br />
			نگران نباش! اگر در {{job.SourceTypeTitle}} {{job.SourceName}} متوجه شدی که این آگهی مناسب نیست، با زدن دکمه‌ی
			<span class="fw-extrabold"> بازگشت </span>
			به جستجوی خودت در کارپیشه برمی‌گردی.
		</div>
		<div class="border-gray border-top py-2 my-2" *ngIf="!user">
			<div> قبل از رفتن در کارپیشه ثبت‌نام کن تا آگهی‌های مشابه هر موقع ثبت شد، بهت خبر بدیم.</div>
			<app-login [inline]="true" [flat]="true" [heading]="''" [intro]="''" registerType="Seeker"
				(auth)="job._hideLink=true">
			</app-login>
			<div class="py-2" *ngIf="!job._hideLink">
				<a class="btn btn-link f-blue w-100" title="تماس با کارفرما" (click)="replaceState(job.SourceUrl)"
					[href]="job.SourceUrl">بدون ثبت‌نام آگهی رو در {{job.SourceName}} ببین</a>
			</div>
		</div>
		<div class="border-gray border-top py-2 my-2" *ngIf="user">
			<label class="mx-1 mb-0 d-flex align-items-center">
				<input type="checkbox" name="auto-redirect" [(ngModel)]="autoRedirect" />
				<span> برای آگهی‌های بعدی این صفحه رو نشونم نده</span>
			</label>
			<div class="py-2">
				<a class="btn btn-secondary w-100 f-dark-blue" title="تماس با کارفرما" (click)="replaceState(job.SourceUrl)"
					[href]="job.SourceUrl">
					<img style="width: 24px;height: 24px" class="ml-1" *ngIf="job.SourceDomain" [src]="getFavIconSrc()" />
					آگهی رو در {{job.SourceName}} ببین</a>
			</div>
		</div>
	</div>
</ngx-smart-modal>
<app-report-job [job]="job" #reportJob (onReport)="onReport()"></app-report-job>